import React from 'react'
import {
  debounce,
} from 'lodash'
import 'semantic-ui-css/semantic.min.css'

const SearchBar = ({
  onSearch = () => { },
} = {}) => {
  const onSearchDebounced = debounce(onSearch, 400)
  const onChange = ({
    target: {
      value = "",
    } = {},
  } = {}) => {
    onSearchDebounced(value)
  }

  return (
    <div className="ui category search transaction-searchbar">
      <div className="ui icon input">
        <input
          className="prompt"
          type="text"
          placeholder="Search for..."
          onChange={onChange}
        />
        <i className="search icon" />
      </div>
      <div className="results" />
    </div>
  )
}
export default SearchBar
